export const LOAD_INTERNAL_PRODUCTS = 'LOAD_INTERNAL_PRODUCTS';
export type LOAD_INTERNAL_PRODUCTS = typeof LOAD_INTERNAL_PRODUCTS;

export interface LoadInternalProducts {
    type: LOAD_INTERNAL_PRODUCTS;
}

export function loadInternalProductsAction(): LoadInternalProducts {
    return {
        type: LOAD_INTERNAL_PRODUCTS
    };
}
